import { IDeliveryAddress } from '../interfaces/IDeliveryAddress';
import { IOrder } from '../interfaces/IOrder';
import { IOrderItem } from '../interfaces/IOrderItem';
import { IPaymentMethod } from '../interfaces/IPaymentMethod';

export function generateMessage(
  fullPedido: Partial<IOrder> & {
    deliveryAddress?: Partial<IDeliveryAddress> | undefined;
    orderPayment: Partial<IPaymentMethod> & {
      companyPaymentMethod?: any;
    };
    items: Partial<IOrderItem>[];
  },
): string {
  const separator = `\n\n------------------------\n\n`;

  const messages = {
    2: `Pedido: #${fullPedido.id}\n\nSeu pedido foi negado!`,
    // 4: `Pedido: #${fullPedido.pedido_venda.id}\n\nSeu pedido está pronto!\n\nVá até nosso estabelecimento para buscá-lo.`,
    5: `Pedido: #${fullPedido.id}\n\nSeu pedido saiu para entrega!\n\nFique esperto(a)! Logo logo chegará.`,
    6: `Pedido: #${fullPedido.id}\n\nSeu pedido foi finalizado!\n\nAgradecemos sua preferência.`,
    9: `Pedido: #${fullPedido.id}\n\nSeu pedido foi cancelado!`,
    10: `Pedido: #${fullPedido.id}\n\nVocê cancelou o pedido!`,
    11: `Pedido: #${fullPedido.id}\n\nSeu pedido está pronto!\n\nVá até nosso estabelecimento para buscá-lo.`,
    12: `Pedido: #${fullPedido.id}\n\nSeu pedido está em separação!\n\nAssim que ele estiver pronto, te avisaremos.`,
  };

  const BRLMoneyFormat = {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  };

  let finalMessage = `Olá, ${
    fullPedido?.customer?.tradingName?.split(' ')[0] ?? 'Venda balcão'
  }.\n\nSeu pedido foi realizado!${separator}*Produtos:*\n\n`;

  fullPedido.items.forEach((item) => {
    const quantity = item.portioned
      ? Number(item.quantity) >= 1
        ? Number(item.quantity).toFixed(3)
        : Number(item.quantity) *
          Number(item.measurementUnit[0].quantityPortion)
      : Number(item.quantity);

    const unitOfMeasurement = item.portioned
      ? Number(item.quantity) >= 1
        ? item.measurementUnit[0].acronym
        : item.measurementUnit[0].acronymPortion
      : 'x';

    finalMessage += `${quantity}${unitOfMeasurement} ${
      !item.colorName && item.sizeName
        ? `Pizza ${String(item.sizeName).toLowerCase()}`
        : item.colorName
        ? `${item.productName} - ${item.productGridName} - ${
            item.colorName
          } - ${Number(item.totalPrice).toLocaleString(
            'pt-BR',
            BRLMoneyFormat,
          )}`
        : `${item.productName} - ${Number(item.totalPrice).toLocaleString(
            'pt-BR',
            BRLMoneyFormat,
          )}`
    }`;

    finalMessage += `\n`;

    item.childOrderItems?.forEach((complemento: any) => {
      finalMessage += `    ${Number(complemento.quantity)}x ${
        complemento.productName
      }`;

      if (Number(complemento.totalPrice)) {
        finalMessage += ` - ${Number(complemento.totalPrice).toLocaleString(
          'pt-BR',
          BRLMoneyFormat,
        )}`;
      }

      finalMessage += `\n`;
    });

    if (item.observation) {
      finalMessage += `    *Observação:* _${item.observation}_\n\n`;
    }
  });

  finalMessage += `${separator.substr(1)}*Pedido #${fullPedido.id}*\n\n`;

  if (fullPedido.observation) {
    finalMessage += `*Observação do Pedido:* ${fullPedido.observation}\n\n`;
  }

  if (fullPedido?.customer?.tradingName) {
    finalMessage += `*Cliente:* ${fullPedido?.customer?.tradingName}`;
  }

  if (fullPedido?.customer?.phoneNumber) {
    finalMessage += `\n*Telefone:* ${fullPedido?.customer?.phoneNumber}${separator}`;
  }

  const { itemsTotalPrice, deliveryFee, totalDiscount, changeFor } = fullPedido;

  if (fullPedido.deliveryAddress) {
    const linkEndereco = `https://waze.com/ul?ll=${fullPedido.deliveryAddress.latitude},${fullPedido.deliveryAddress.longitude}&z=10`;
    finalMessage += `*Endereço de entrega:*\n\n*Logradouro:* ${
      fullPedido.deliveryAddress.address.logradouro
    }\n*Número:* ${fullPedido.deliveryAddress.address.numero}\n*Bairro:* ${
      fullPedido.deliveryAddress.address.bairro
    }\n*CEP:* ${fullPedido.deliveryAddress.address.cep}\n*Cidade:* ${
      fullPedido.deliveryAddress.address.cidade
    }\n*Estado:* ${fullPedido.deliveryAddress.address.estado}\n*Complemento:* ${
      fullPedido.deliveryAddress.address?.complemento || 'Sem complemento'
    }\n*Link Waze:* ${linkEndereco}${separator}`;
  }

  finalMessage += `*Pagamento:*\n\n*Forma de pagamento*: ${fullPedido.orderPayment.companyPaymentMethod.paymentMethod.description}\n`;

  if (Number(deliveryFee)) {
    finalMessage += `*Taxa de entrega:* ${Number(deliveryFee).toLocaleString(
      'pt-BR',
      BRLMoneyFormat,
    )}\n`;
  }

  if (Number(changeFor)) {
    finalMessage += `*Troco:* ${Number(changeFor).toLocaleString(
      'pt-BR',
      BRLMoneyFormat,
    )}\n`;
  }

  if (Number(totalDiscount)) {
    finalMessage += `*Cupom de desconto (${
      fullPedido.discountCoupon?.code
    }): - ${Number(totalDiscount).toLocaleString('pt-BR', BRLMoneyFormat)}\n`;
  }

  finalMessage += `*Total*: ${Number(
    Number(itemsTotalPrice) + Number(deliveryFee) - Number(totalDiscount),
  ).toLocaleString('pt-BR', BRLMoneyFormat)}`;

  Object.assign(messages, { 3: finalMessage });

  return messages[3 as 2];
}
